export default "__VITE_ASSET__5359bad3__"